/**
 * @generated SignedSource<<186840ed6620b13e65b6c4cd6e23e266>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectSidePanelNotes_project$data = {
  readonly id: number;
  readonly isTemplate: boolean;
  readonly notes: ReadonlyArray<{
    readonly created_at: string;
    readonly created_by: string | null | undefined;
    readonly creator_email: string | null | undefined;
    readonly id: number;
    readonly note: string;
    readonly updated_at: string;
    readonly user_account: {
      readonly id: number;
      readonly user: {
        readonly email: string;
        readonly first_name: string | null | undefined;
        readonly id: number;
        readonly last_name: string | null | undefined;
      };
    } | null | undefined;
    readonly user_id: number | null | undefined;
  }>;
  readonly teamId: number | null | undefined;
  readonly " $fragmentType": "ProjectSidePanelNotes_project";
};
export type ProjectSidePanelNotes_project$key = {
  readonly " $data"?: ProjectSidePanelNotes_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectSidePanelNotes_project">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectSidePanelNotes_project",
  "selections": [
    (v0/*: any*/),
    {
      "alias": "isTemplate",
      "args": null,
      "kind": "ScalarField",
      "name": "is_template",
      "storageKey": null
    },
    {
      "alias": "teamId",
      "args": null,
      "kind": "ScalarField",
      "name": "team_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "order_by",
          "value": {
            "created_at": "asc"
          }
        }
      ],
      "concreteType": "notes",
      "kind": "LinkedField",
      "name": "notes",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "note",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "created_at",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updated_at",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "creator_email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "created_by",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "user_id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "user_accounts",
          "kind": "LinkedField",
          "name": "user_account",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "users",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "first_name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "last_name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "email",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "notes(order_by:{\"created_at\":\"asc\"})"
    }
  ],
  "type": "projects",
  "abstractKey": null
};
})();

(node as any).hash = "64476eb3d3ce104ac9901583d73446a1";

export default node;
